import { render, staticRenderFns } from "./FormAddFavoris.vue?vue&type=template&id=3f3e8800&"
import script from "./FormAddFavoris.vue?vue&type=script&lang=js&"
export * from "./FormAddFavoris.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports